import { Button, CardBody, ItemCreditCard, LoadingSkeleton } from 'components';
import ButtonReload from 'components/atoms/Button-reload/Button-reload';
import { usePaymentMethod } from '../hooks/PaymentMethod.hook';
import './PaymentMethod.css';
import { PaymentMethodForm } from './PaymentMethodForm';

interface PaymentMethodProps {
  onSelectPaymentMethod: (method: string | null) => void;
}

export const PaymentMethod = ({
  onSelectPaymentMethod,
}: PaymentMethodProps) => {
  const {
    paymentLink,
    isPaymentLinkModalOpen,
    isGeneratingLink,
    generatePaymentLink,
    handleError,
    handleRefreshCards,
    isLoading,
    error,
    selectedMethod,
    handleMethodChange,
    handleCardSelection,
    creditCards,
    showNewCardForm,
    selectedCard,
    handleShowNewCardForm,
    handleIsPaymentLinkModalOpen,
  } = usePaymentMethod({ onSelectPaymentMethod });

  return (
    <CardBody>
      <div className="form__coupon__container">
        <div className="form__coupon__title">
          <h5>MÉTODO DE PAGO</h5>
          {selectedMethod === 'credit_card' && (
            <ButtonReload onClick={handleRefreshCards} />
          )}
        </div>
        <p className="text-yellow-500 mt-2">
          Seleccione el método de pago que desea usar
        </p>
        <div>
          {isLoading ? (
            <div className="loading-spinner">
              <LoadingSkeleton count={2} />
            </div>
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : (
            <div>
              <div className="payment-method-radio-group">
                <label className="payment-method-radio-item">
                  <input
                    type="radio"
                    value="credit_card"
                    checked={selectedMethod === 'credit_card'}
                    onChange={() => handleMethodChange('credit_card')}
                  />
                  Tarjeta de crédito o débito
                </label>
              </div>

              {selectedMethod === 'credit_card' && (
                <div className="payment-method-card-section">
                  {creditCards.length > 0 && !showNewCardForm && (
                    <div className="payment-method-card-list">
                      {creditCards.map((card) => (
                        <ItemCreditCard
                          key={`item__credit__card__${card.id}`}
                          id={card.id}
                          onClickSelect={() => handleCardSelection(card.id)}
                          lastDigits={card.last4}
                          brand={card.brand}
                          isPrincipal={card.is_principal}
                          isSelected={selectedCard === card.id}
                          expMonth={card.exp_month}
                          expYear={card.exp_year}
                        />
                      ))}
                    </div>
                  )}

                  {!showNewCardForm ? (
                    <>
                      {creditCards.length === 0 && (
                        <p>
                          No se encontraron tarjetas de crédito. Por favor, crea
                          una.
                        </p>
                      )}
                      <Button
                        testid="btn_add_credit_card"
                        onClick={() => handleShowNewCardForm(!showNewCardForm)}
                        isDisabled={isLoading}
                        typeStyle={'rounded'}
                        template={'primary'}
                        color={'primary'}
                        size={'small'}
                      >
                        Agregar tarjeta
                      </Button>
                    </>
                  ) : (
                    <>
                      <PaymentMethodForm
                        isPaymentMethodLink={false}
                        handleRefreshCards={handleRefreshCards}
                        handleShowNewCardForm={handleShowNewCardForm}
                        handleError={handleError}
                        isGeneratingLink={isGeneratingLink}
                        generatePaymentLink={generatePaymentLink}
                      />
                    </>
                  )}
                </div>
              )}
              <label className="payment-method-radio-item payment-method-radio-item-disabled">
                <input
                  type="radio"
                  value="ath_movil"
                  checked={selectedMethod === 'ath_movil'}
                  onChange={() => handleMethodChange('ath_movil')}
                  disabled
                />
                ATH Móvil (Próximamente)
              </label>
            </div>
          )}
        </div>

        {isPaymentLinkModalOpen && (
          <div className="payment-method-modal">
            <div className="payment-method-modal-content">
              <div className="payment-method-modal-header">
                <h3 className="payment-method-modal-title">
                  Link para Agregar Método de Pago
                </h3>
                <p className="payment-method-modal-description">
                  Utiliza el siguiente enlace para agregar tu método de pago de
                  forma segura:
                </p>
              </div>
              <div className="payment-method-modal-link">
                <a
                  href={paymentLink || '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {paymentLink}
                </a>
              </div>
              <p>
                Este enlace es válido por 24 horas y solo puede ser utilizado
                una vez.
              </p>
              <div className="payment-method-modal-footer">
                <Button
                  onClick={() => handleIsPaymentLinkModalOpen(false)}
                  isDisabled={isGeneratingLink}
                  typeStyle={'rounded'}
                  template={'primary'}
                  color={'primary'}
                  size={'small'}
                  label="Cerrar"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </CardBody>
  );
};
